import VueRouter from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = VueRouter
import router from '@/router/router.js';
import store from '@/store/index';

const areaId = () => store.getters['getCurrentAreaId'];

export default {
	// namespaced: true,
	actions: {
    async change({dispatch}, route) {
      let currentRoute = router.currentRoute.path
      if(currentRoute === route) return

      router.push(route).catch(err => {
        if(isNavigationFailure(err, NavigationFailureType.cancelled)) dispatch('changeHandler')
      })
    },
    async changeWithQuery(context, {route, query}) {
      let currentRoute = router.currentRoute.path

      if(currentRoute === route) router.push({query})
      else router.push({path: route, query})
    },

    // routes ------------------------------------------------------------------
    goToLogin: ({dispatch}) => dispatch('api/auth/loginWithSSO', undefined, {root: true}),
		goToRegister: ({dispatch}) => dispatch('change', '/register'),

    async goToHome({commit, dispatch}) {
      dispatch('sidebar/close', null, {root: true})
      dispatch('root/updateCssSettings', {primaryColour:''}, {root: true})
      await dispatch('change', '/')
			commit('loading/FIRST_LOBBY_LOAD', true, {root: true});
    },
    async goToCurrentArea({dispatch}) {
			if(!areaId()) return dispatch('goToHome') //error handle ie: if guest + no area access
      if(document.fullscreenElement) document.exitFullscreen()
      await dispatch('change', `/space/${areaId()}`)
    },
    goToArea: ({dispatch},id) => dispatch('change', `/space/${id || areaId()}`), //pass an id to change route to a new area (don't pass if you want to route to current users area)
    goToViewRoom: ({dispatch},id) => dispatch('changeWithQuery', {route: `/space/${areaId()}`, query: {room: id}}),
		goToRoom: ({dispatch}, roomId) => dispatch('change', `/room/${roomId}`),
		goToCreateArea: ({dispatch}) => dispatch('change', '/create-space'),
		// area admin --------------------------------------------------------------
    goToManageUsers: ({dispatch}) => dispatch('change', `/space/${areaId()}/admin/manage-users`),
    goToCustomise: ({dispatch}) => dispatch('change', `/space/${areaId()}/admin/customise`),
    goTo404: ({dispatch}) => dispatch('change', `/404`),

    // --------------------------------------------------------------- //
    addQuery: (context, query) => { if(query) router.push({ query }) },
    clearQuery: () => {
      // check if router is already routing
      if (router.history.pending == null) {
        router.replace({'query': null})
      }
    },
    getQueryValue(context, name) {
      let url = new URL(window.location.href)
      return url.searchParams.get(name)
    },
	}
}
